'use strict';

/**
* Applies responsive text position and alignment classes
* based on screen width and data attributes.
* @param {jQuery} $carousel - The carousel element to apply classes to.
*/
function applyTextPositionClasses($carousel) {
    var width = window.innerWidth;

    $carousel.find('.position-over-image').each(function () {
        var $textBlock = $(this);
        if (!$textBlock.length) return;

        var xsSettings = $textBlock.data('xs-settings') || {};
        var smSettings = $textBlock.data('sm-settings') || {};
        var mdSettings = $textBlock.data('md-settings') || {};

        let textPos = '';
        let textAlign = '';

        if (width <= 480) {
            textPos = xsSettings.xsTextPosition;
            textAlign = xsSettings.xsTextAlign;
        } else if (width < 1024) {
            textPos = smSettings.smTextPosition;
            textAlign = smSettings.smTextAlign;
        } else {
            textPos = mdSettings.mdTextPosition;
            textAlign = mdSettings.mdTextAlign;
        }

        if (textPos && textAlign) {
            $textBlock.addClass('text-position-' + textPos + ' text-align-' + textAlign);
        }
    });
}

/**
* Initializes slick carousel and applies relevant classes based on settings.
* @param {jQuery} $carousel - The carousel element to initialize.
*/
function initCarousel($carousel) {
    var $slides = $carousel.find('.experience-slides');
    var xsSettings = $carousel.data('xs-settings') || {};
    var smSettings = $carousel.data('sm-settings') || {};
    var mdSettings = $carousel.data('md-settings') || {};

    applyTextPositionClasses($carousel);

    if (window.innerWidth <= 768 && xsSettings.arrows && xsSettings.arrowsPosition) {
        $carousel.addClass('arrows-position-' + xsSettings.arrowsPosition.toLowerCase());
    } else if (window.innerWidth <= 1024 && smSettings.arrows && smSettings.arrowsPosition) {
        $carousel.addClass('arrows-position-' + smSettings.arrowsPosition.toLowerCase());
    } else if (window.innerWidth > 1024 && mdSettings.arrows && mdSettings.arrowsPosition) {
        $carousel.addClass('arrows-position-' + mdSettings.arrowsPosition.toLowerCase());
    }

    var config = {
        infinite: mdSettings.infinite,
        dots: mdSettings.dots,
        arrows: mdSettings.arrows,
        slidesToShow: mdSettings.slidesToShow,
        slidesToScroll: mdSettings.slidesToScroll,
        autoplay: mdSettings.autoplay,
        autoplaySpeed: mdSettings.autoplaySpeed,
        centerMode: mdSettings.centerMode,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: smSettings.infinite,
                    dots: smSettings.dots,
                    arrows: smSettings.arrows,
                    slidesToShow: smSettings.slidesToShow,
                    slidesToScroll: smSettings.slidesToScroll,
                    autoplay: smSettings.autoplay,
                    autoplaySpeed: smSettings.autoplaySpeed,
                    centerMode: smSettings.centerMode
                }
            },
            {
                breakpoint: 768,
                settings: {
                    infinite: xsSettings.infinite,
                    dots: xsSettings.dots,
                    arrows: xsSettings.arrows,
                    slidesToShow: xsSettings.slidesToShow,
                    slidesToScroll: xsSettings.slidesToScroll,
                    autoplay: xsSettings.autoplay,
                    autoplaySpeed: xsSettings.autoplaySpeed,
                    centerMode: xsSettings.centerMode
                }
            }
        ]
    };

    $slides.on('init', function () {
        $(this).css('visibility', 'visible');
    });
    $slides.slick(config);
}
$('.ckc-slick-carousel').each(function () {
    const $carousel = $(this);
    const $slides = $carousel.find('.experience-slides');

    // Avoid duplicate slick initialization
    if ($slides.hasClass('slick-initialized')) {
        $slides.slick('unslick');
    }

    initCarousel($carousel);
});

// Only bind logic if .ckc-carousel exists inside .tab-structure-section
if ($('.tab-structure-section .ckc-carousel').length > 0) {
    // Bind click handler
    $(document).on('click', '.tab-structure-section .nav-link', function () {
        var $btn = $(this);
        var $section = $btn.closest('.tab-structure-section');
        var $carousel = $section.find('.ckc-slick-carousel');
        var $slides = $carousel.find('.experience-slides');

        // Destroy if already initialized
        if ($slides.hasClass('slick-initialized')) {
            $slides.slick('unslick');
            $slides.addClass('invisible tab-structure-hidden');
        }

        setTimeout(function () {
            initCarousel($carousel);
            $slides.removeClass('invisible tab-structure-hidden');
        }, 500);
    });
}
